"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = require("prop-types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var LoadingSpinner = function LoadingSpinner(_ref) {
  var isAbsolute = _ref.isAbsolute,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["isAbsolute", "className"]);

  return /*#__PURE__*/_react.default.createElement(Spinner, _extends({
    id: "loadingSpinner",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    className: className,
    isAbsolute: isAbsolute
  }, rest), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("path", {
    id: "a",
    d: "M0 0h40v40H0z"
  })), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement(Circle, {
    cx: "40",
    cy: "40",
    r: "38",
    opacity: "0.1",
    strokeWidth: "2.817"
  }), /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(40)"
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/_react.default.createElement("use", {
    href: "#a"
  })), /*#__PURE__*/_react.default.createElement(Circle, {
    cy: "40",
    r: "38",
    strokeWidth: "2.817",
    mask: "url(#b)"
  }))));
};

var Spinner = _styledComponents.default.svg.withConfig({
  displayName: "Spinner"
})(["opacity:1;height:80px;width:80px;min-width:80px;min-height:80px;transform-origin:40px 40px 40px;transition:0.5s;animation:spinnerAnimation 1.3s infinite cubic-bezier(0.53,0.21,0.29,0.67);", ";@keyframes spinnerAnimation{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}"], function (_ref2) {
  var isAbsolute = _ref2.isAbsolute;
  return isAbsolute ? (0, _styledComponents.css)(["position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:3;"]) : (0, _styledComponents.css)(["align-self:center;"]);
});

var Circle = _styledComponents.default.circle.withConfig({
  displayName: "Circle"
})(["stroke:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.brand.primary;
});

LoadingSpinner.defaultProps = {
  isAbsolute: false
};
LoadingSpinner.propTypes = {
  className: _propTypes.string,
  isAbsolute: _propTypes.bool
};
var _default = LoadingSpinner;
exports.default = _default;